export const LOAD_LABELS = 'LOAD_LABELS';
export const LOAD_LANGUAGES = 'LOAD_LANGUAGES';
export const CHANGE_DEFAULT_LANGUAGES = 'CHANGE_DEFAULT_LANGUAGES';
export const LOAD_DEFAULT_STYLE = 'LOAD_DEFAULT_STYLE';
